export const config={
app:{
    host:"https://bulut.bonbon-erp.com",
    port: 3000
},
api:{
    host:"https://bulut.bonbon-erp.com/api",
    port: 3000
},
kvk:{
    host:"https://bulut.bonbon-erp.com/kvk",
    port: 3000
},
payments:{
    host:"https://bulut.bonbon-erp.com/payments",
    port: 3000
},
ws:{
    host:"wss://bulut.bonbon-erp.com/ws",
    port: 3001
},
webpack: {
    host: "http://localhost:8080",
    port: 8080
},
snelstart:{
    host:"https://bulut.bonbon-erp.com/snelstart",
    port: 3001
},
token: "AIzaSyCdYmiOMYeEl-35AJeu5s12jEHbuVofhQU"
}
